export function createPauseableTimeout(callback, duration) {
  let startMs
  let remain = duration
  let timerId = -1
  let isPaused = false

  return {
    pause() {
      isPaused = true
      remain -= Date.now() - startMs
      this.resetStartMs()
      clearTimeout(timerId)
    },
    continue() {
      if (isPaused) {
        this.reset()
        timerId = setTimeout(callback, remain)
      }
    },
    start(startDuration = duration) {
      this.reset()
      remain = startDuration === duration ? duration : startDuration
      timerId = setTimeout(callback, remain)
    },
    reset() {
      isPaused = false
      this.resetStartMs()
      clearTimeout(timerId)
    },
    resetStartMs() {
      startMs = Date.now()
    },
    getTimerId() {
      return timerId
    }
  };
}


// WEBPACK FOOTER //
// ./src/libs/timeout/index.js